var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog"},[_c('TitleHeader',{attrs:{"title":"Blog"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/svg/coming-soon.svg"),"alt":"brush"}}),_c('h3',[_vm._v("Coming soon")])])
}]

export { render, staticRenderFns }